import * as React from 'react';
import { ITicketCannedResponse } from '@nkr/models/index';
import { OverlayTrigger, Button, Popover } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';

interface IProps {
    cannedResponses: ITicketCannedResponse[],
    onApply: (id: number) => void,
    onClose: () => void
}

class CannedResponses extends React.Component<IProps, {}> {
    private getCannedResponse = (message: string) => {
        return (
            <Popover bsSize='lg' style={{ zIndex: 999999 }}>
                {ReactHtmlParser(message)}
            </Popover>
        );
    }

    render = () => {
        return (
            <>
                <div style={{ padding: 10 }}>
                    <h1 className='text-center'>Canned Responses</h1>

                    <div style={{ marginBottom: 20 }}>
                        {this.props.cannedResponses.map((cr, index) =>
                            <div key={'cr-' + index} style={{ display: 'flex', justifyContent: 'space-between', padding: 5, border: '1px solid #ddd', boxShadow: '1px', cursor: 'pointer' }}>
                                <OverlayTrigger container={this} placement='bottom' trigger={['hover', 'focus']} overlay={this.getCannedResponse(cr.message)}>
                                    <div>{cr.title}</div>
                                </OverlayTrigger>
                                <Button bsSize="xs" onClick={() => this.props.onApply(cr.id)}>Insert Response</Button>
                            </div>
                        )}
                    </div>

                    <div className='text-center'>
                        <Button bsStyle='primary' onClick={this.props.onClose}>Cancel</Button>
                    </div>
                </div>
            </>
        );
    }
}

export default CannedResponses;